<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-layout wrap pt-10>
      <v-flex xs12 md12 text-center>
        <span style="font-size:20px;font-weight:500;">Create your account</span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center pt-3>
      <v-flex xs12 md3 pa-5>
        <v-layout wrap pb-5>
          <v-flex xs12 md6 text-center>
            <v-btn
              text
              color="black"
              small
              block
              :disabled="inptDisable"
              :ripple="false"
              class="text-capitalize"
              @click="investoracc"
            >Individual Investor</v-btn>
            <v-progress-linear :value="investorBar" color="#fb6b0b" height="4"></v-progress-linear>
          </v-flex>
          <v-flex xs12 md6 text-center>
            <v-btn
              text
              block
              color="black"
              small
              :disabled="inptDisable"
              :ripple="false"
              class="text-capitalize"
              @click="companyacc"
            >Company</v-btn>
            <v-progress-linear :value="companyBar" color="#fb6b0b" height="4"></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-text-field
          ref="userName"
          v-model="userName"
          :rules="[rules.required,rules.username]"
          label="Username"
          :error-messages="msg_username"
          color="#26af82"
          :disabled="inptDisable"
          required
        ></v-text-field>
        <v-layout>
          <v-flex xs3 md3 wrap>
            <v-select
              v-model="countryCode"
              :items="countryCodes"
              :rules="[rules.required]"
              color="#26af82"
              label="Code"
              required
            ></v-select>
          </v-flex>
          <v-flex xs9 md9 pl-5>
            <v-text-field
              ref="phoneNo"
              v-model="phoneNo"
              :rules="[rules.required,rules.phone]"
              label="Phone Number"
              :error-messages="msg_phoneno"
              color="#26af82"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-text-field
          ref="mailId"
          v-model="mailId"
          :rules="[rules.required,rules.email]"
          label="Mail ID"
          :error-messages="msg_mailId"
          color="#26af82"
          required
        ></v-text-field>
        <v-text-field
          ref="password"
          color="#26af82"
          v-model="password"
          :rules="[rules.required,rules.min,rules.password]"
          :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordShow ? 'text' : 'password'"
          @click:append="passwordShow = !passwordShow"
          label="Password"
          required
        ></v-text-field>
        <v-text-field
          ref="confPassword"
          v-model="confPassword"
          :rules="[rules.required,rules.min,rules.password]"
          :append-icon="passwordShow2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordShow2 ? 'text' : 'password'"
          @click:append="passwordShow2 = !passwordShow2"
          :error-messages="msg_password"
          label="Confirm Password"
          color="#26af82"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md12 pb-10 text-center>
        <span style="font-size:10px;color:red;">{{msg}}</span>
        <br />
        <v-btn
          width="220"
          class="text-capitalize"
          dark
          small
          :ripple="false"
          color="#26af82"
          @click="submit"
        >Submit</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["signupData"],
  data() {
    return {
      regurl: "/user/individualregister",
      userName: null,
      countryCode: "+91",
      phoneNo: null,
      mailId: null,
      password: null,
      confPassword: null,
      countryCodes: ["+61", "+65", "+91"],
      investor: true,
      company: false,
      investorBar: 100,
      companyBar: 0,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters",
        username: value => (!!value && value.length >= 4) || "Min 4 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid Mail ID";
        },
        phone: value => {
          const pattern = /^[0-9+]*$/;
          return pattern.test(value) || "Invalid Phone Number";
        },
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
          return (
            pattern.test(value) ||
            "Must contain atleast one uppercase, one lowercase,one digit and one special characters"
          );
        }
      },
      msg: null,
      ServerError: false,
      passwordShow: false,
      passwordShow2: false,
      formHasErrors: false,
      msg_username: null,
      msg_mailId: null,
      msg_phoneno: null,
      msg_password: null,
      appLoading: false,
      inptDisable: false,
      userType: null,
      userId: null,
      authcode: null
    };
  },
  mounted() {
    if (this.signupData.userId) {
      this.inptDisable = this.signupData.inptDisable;
      this.userId = this.signupData.userId;
      this.authcode = this.signupData.authcode;
      this.userName = this.signupData.userName;
      this.countryCode = this.signupData.countryCode;
      this.phoneNo = this.signupData.phoneNo;
      this.mailId = this.signupData.mailId;
      this.password = this.signupData.password;
      this.confPassword = this.signupData.confPassword;
      this.userType = this.signupData.userType;
      if (this.userType == "Company") this.companyacc();
      if (this.userType == "Individual") this.investoracc();
    }
  },
  watch: {
    userName: function() {
      axios({
        method: "GET",
        url: "/user/check/username",
        params: {
          username: this.userName,
          id: this.userId
        }
      })
        .then(response => {
          if (response.data.status == false)
            this.msg_username = response.data.msg;
          else this.msg_username = null;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    mailId: function() {
      axios({
        method: "GET",
        url: "/user/check/email",
        params: {
          email: this.mailId,
          id: this.userId
        }
      })
        .then(response => {
          if (response.data.status == false)
            this.msg_mailId = response.data.msg;
          else this.msg_mailId = null;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    phoneNo: function() {
      var data = {};
      data["phone"] = this.phoneNo;
      data["prefix"] = this.countryCode;
      data["id"] = this.userId;
      axios({
        method: "POST",
        url: "/user/check/phone",
        data: data
      }).then(response => {
        if (response.data.status == false) this.msg_phoneno = response.data.msg;
        else this.msg_phoneno = null;
      });
    },
    countryCode: function() {
      var data = {};
      data["phone"] = this.phoneNo;
      data["prefix"] = this.countryCode;
      data["id"] = this.userId;
      axios({
        method: "POST",
        url: "/user/check/phone",
        data: data
      })
        .then(response => {
          if (response.data.status == false)
            this.msg_phoneno = response.data.msg;
          else this.msg_phoneno = null;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    confPassword: function() {
      if (this.password != this.confPassword)
        this.msg_password = "Passwords not matching";
      else this.msg_password = null;
    },
    password: function() {
      if (this.signupData.userId) {
        if (this.password != this.confPassword)
          this.msg_password = "Passwords not matching";
        else this.msg_password = null;
      }
      if (this.confPassword) {
        if (this.password != this.confPassword)
          this.msg_password = "Passwords not matching";
        else this.msg_password = null;
      }
    }
  },
  computed: {
    form() {
      return {
        userName: this.userName,
        phoneNo: this.phoneNo,
        mailId: this.mailId,
        password: this.password,
        confPassword: this.confPassword
      };
    }
  },
  methods: {
    investoracc() {
      this.regurl = "/user/individualregister";
      this.investor = true;
      this.company = false;
      this.investorBar = 100;
      this.companyBar = 0;
    },
    companyacc() {
      this.regurl = "/user/companyregister";
      this.company = true;
      this.investor = false;
      this.companyBar = 100;
      this.investorBar = 0;
    },
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        this.$refs[f].validate(true);
      });
      if (this.userId) this.regurl = "/user/PreEdit";

      if (!Number(this.phoneNo)) this.formHasErrors = true;
      this.appRegister();
    },
    appRegister() {
      if (!this.formHasErrors) {
        var regdata = {};
        regdata["username"] = this.userName;
        regdata["password"] = this.password;
        regdata["cpassword"] = this.confPassword;
        regdata["prefix"] = this.countryCode;
        regdata["phone"] = this.phoneNo;
        regdata["email"] = this.mailId;
        regdata["id"] = this.userId;
        regdata["code"] = this.authcode;
        this.appLoading = true;
        axios({
          method: "POST",
          url: this.regurl,
          // url: "/user/adminregister",
          data: regdata
        })
          .then(response => {
            this.appLoading = false;
            if (response.data.status) {
              if (this.company) this.userType = "Company";
              if (this.individual) this.userType = "Individual";
              // this.msg = "Successfully Registered";
              this.$emit("stepper", {
                winStep: 1,
                userType: this.userType,
                userId: response.data.id,
                userName: this.userName,
                countryCode: this.countryCode,
                phoneNo: this.phoneNo,
                mailId: this.mailId,
                password: this.password,
                confPassword: this.confPassword,
                authcode: response.data.code
              });
            } else {
              this.msg = response.data.msg;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.appLoading = false;
        // this.msg = "Please Validate INput";
      }
    }
  }
};
</script>